<div class="text-[28px] p-6 mb-5 dark:text-white">Theme Settings</div>
<div *ngFor="let name of getObjectKeys(colors)" class="mb-8 px-6">
  <div class="flex justify-start items-center">
    <h2 class="text-xl font-bold mr-4 dark:text-white">{{ name | titlecase }}</h2>
    <button class="primary-button text-xs" (click)="applyTheme(name)">
      Apply Theme
    </button>
  </div>
  <div class="flex flex-row gap-4  mt-4 w-full overflow-auto">
    <div *ngFor="let key of getObjectKeys(colors[name])" class="flex flex-col items-center">
      <div [style.background-color]="colors[name][key]" class="w-24 h-24 rounded-md flex items-center justify-center">
      </div>
      <span class="mt-2 text-sm text-gray-600 dark:text-white">{{ key }}</span>
    </div>
  </div>
</div>
